import { Cpu, Lock, Sparkles, Zap } from 'lucide-react'
import { DatabaseWithRestApi } from '../api'

export function ChannelsCard() {
    return (
        <section className="py-20 bg-background">
            <div className="mx-auto max-w-7xl px-6">
                {/* Container Card with rounded corners and custom background - wraps all content */}
                <div className="rounded-3xl p-8 md:p-12 space-y-8 md:space-y-12 bg-black dark:bg-zinc-950">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        {/* Left Side - Title and Subtitle */}
                        <div className="space-y-6">
                            <div className="space-y-4">
                                <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                                    Secure Database
                                    <br />
                                    <span className="text-primary">AI Agents Integration</span>
                                </h2>
                                <p className="text-lg text-gray-300 leading-relaxed">
                                    Seamlessly connect your applications with our AI Agents. 
                                    Built for businesses who need reliable, scalable, and secure 
                                    database with real-time synchronization.
                                </p>
                            </div>
                        </div>

                        {/* Right Side - Database Component */}
                        <div className="flex justify-center lg:justify-end">
                            <DatabaseWithRestApi
                                title="44Agents Database API"
                                circleText="API"
                                badgeTexts={{
                                    first: "GET",
                                    second: "POST",
                                    third: "PUT",
                                    fourth: "DELETE"
                                }}
                                buttonTexts={{
                                    first: "44Agents",
                                    second: "v2_api"
                                }}
                                lightColor="#00A6F5"
                            />
                        </div>
                    </div>
                    
                    <div className="relative mx-auto grid grid-cols-2 gap-x-3 gap-y-6 sm:gap-8 lg:grid-cols-4">
                        <div className="space-y-3">
                            <div className="flex items-center gap-2">
                                <Zap className="size-4 text-white" />
                                <h3 className="text-sm font-medium text-white">Faaast</h3>
                            </div>
                            <p className="text-gray-300 text-sm">Get instant answers for your customers 24/7 without any waiting time. Your AI responds in seconds, not hours like traditional customer support</p>
                        </div>
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <Cpu className="size-4 text-white" />
                                <h3 className="text-sm font-medium text-white">Powerful</h3>
                            </div>
                            <p className="text-gray-300 text-sm">Handle thousands of customer conversations at the same time without getting tired or overwhelmed.</p>
                        </div>
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <Lock className="size-4 text-white" />
                                <h3 className="text-sm font-medium text-white">Security</h3>
                            </div>
                            <p className="text-gray-300 text-sm">Keep all your business and customer information completely safe and private. Your data is protected on servers hosted in saudi arabia.</p>
                        </div>
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <Sparkles className="size-4 text-white" />
                                <h3 className="text-sm font-medium text-white">AI Powered</h3>
                            </div>
                            <p className="text-gray-300 text-sm">Smart technology that learns and gets better every day from talking to your customers. No complicated setup</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
